import { toast } from "react-toastify";
import { getAccessToken } from "services/accessTokenServices";
import api from "services/api";

export async function getAddressZipCode(zipCode) {
  const accessToken = await getAccessToken();
  const headers = {
    access_token: accessToken
  };

  try {
    const response = await api.get(`/locality/v1/places?zip-code=${zipCode}`, { headers });
    return response.data;
  } catch (err) {
    if (err.response) {
      const erro = err.response.data;
      if (erro) {
        const message = err.response.data.message;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else {
        if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    } else {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }

}
